import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type QuizEditorQuizQuestionFragment = { id: string, order: number, questionId: string, sectionId?: string | null };


export type QuizEditorQuizQuestionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizEditorQuizQuestionFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizEditorQuizQuestion on QuizQuestionSchema {
  id
  order
  questionId
  sectionId
}
    `;